export default __webpack_public_path__ + "static/media/shrutiDsharplow.126c8b9a.wav";